
import React from 'react'
import PropTypes from 'prop-types'
import { mainPageContentLayoutCss, mainPageContentCss } from './styles'

function MainPageContent({ children }) {
  return (
    <div css={mainPageContentLayoutCss}>
      <div css={mainPageContentCss}>{children}</div>
    </div>
  )
}

MainPageContent.propTypes = {
  children: PropTypes.node,
}

export default MainPageContent
